import client from '@/lib/http-client';

const endpoint = '/admin/revenue-stream';

export const getRevenueSummary = (params, callback, errCallback) => {
	client.get(`${endpoint}/summary`, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const getRevenueTransactions = (params, callback, errCallback) => {
	client.get(`${endpoint}/transactions`, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const exportRevenueTransactions = (params, callback, errCallback) => {
	client.get(`${endpoint}/export`, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export default {
	getRevenueSummary,
	getRevenueTransactions,
	exportRevenueTransactions,
};
